import {useEffect} from "react";
import {Typography} from "antd";
import ResultHeaderCell from "../../../Table/ResultHeaderCell";
import UIComponentHelper from "../UIComponentHelper";
import ResultBodyCell from "../../../Table/ResultBodyCell";
import WinFormInput from "../WinFormInput";

export default function CrossSectionEditor({windowName, data, title, targetWindow}) {

    useEffect(() => {
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'lob'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'channel'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'rob'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'left-bank'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'right-bank'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'mann-lob'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'mann-rob'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'mann-channel'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'cont'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'exp'})
        UIComponentHelper.setStyleForTable({targetWindow, windowName, name: 'station_table', skipIndex: [0]})
    }, [data, title, windowName]);

    return (
        <div style={{border: '1px solid #cfcfcf'}}>
            <Typography.Text style={{fontSize: '11pt', fontWeight: 'bold', backgroundColor: 'white', width: '100%', marginLeft: 4}}>
                Cross Section Data - {title}
            </Typography.Text>
            <div style={{backgroundColor: '#f5f5f5', fontSize: '9pt', padding: 2, paddingLeft: 4, paddingRight: 4}}>
                <div style={{display: 'flex', marginBottom: 8}}>
                    <div style={{width: 80}}>
                        Description:
                    </div>
                    <div>
                        <WinFormInput id={`${windowName}-description`} style={{width: 300}}>
                            <Typography.Text ellipsis={true} style={{width: 300}}>
                                {data?.description}
                            </Typography.Text>
                        </WinFormInput>
                    </div>
                </div>
                <div id={windowName} style={{display: 'flex', gap: 12}}>
                    <div>
                        <table style={{width: 220}}>
                            <thead style={{tableLayout: 'fixed', width: '100%', display: 'block'}}>
                            <tr>
                                <td colSpan={4}
                                    style={{textAlign: 'center', backgroundColor: '#008080', color: 'white'}}>Cross
                                    Section Coordinates
                                </td>
                            </tr>
                            <tr>
                                <ResultHeaderCell style={{width: 30}}></ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'center', width: 60,}}>Station</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'center', width: 60,}}>Elevation</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'center', width: 50,}}>n Val</ResultHeaderCell>
                            </tr>
                            </thead>
                        </table>
                        <div style={{overflowY: 'auto', height: 500, backgroundColor: 'white', width: 220}}>
                            <table>
                                <tbody id={`${windowName}-station_table`}>
                                {
                                    data?.sta_elev_data?.map((x, idx) => (
                                        <tr>
                                            <ResultHeaderCell style={{width: 30}}>{idx + 1}</ResultHeaderCell>
                                            <ResultBodyCell
                                                style={{backgroundColor: 'white', width: 60,}}>{x[0]}</ResultBodyCell>
                                            <ResultBodyCell
                                                style={{backgroundColor: 'white', width: 60,}}>{x[1]}</ResultBodyCell>
                                            <ResultBodyCell
                                                style={{backgroundColor: 'white', width: 50,}}>{x[2]}</ResultBodyCell>
                                        </tr>
                                    ))
                                }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div>
                        <table style={{width: '100%', marginBottom: 6}}>
                            <tr>
                                <td colSpan={3}
                                    style={{textAlign: 'center', backgroundColor: '#008080', color: 'white'}}>Downstream
                                    Reach Lengths
                                </td>
                            </tr>
                            <tr>
                                <ResultHeaderCell style={{textAlign: 'center', width: 60,}}>LOB</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'center', width: 60,}}>Channel</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'center', width: 60,}}>ROB</ResultHeaderCell>
                            </tr>
                            <tr>
                                <td style={{width: '33.3%'}}>
                                    <WinFormInput id={`${windowName}-lob`} style={{width: '100%'}}>
                                        {data?.lob}
                                    </WinFormInput>
                                </td>
                                <td style={{width: '33.3%'}}>
                                    <WinFormInput id={`${windowName}-channel`} style={{width: '100%'}}>
                                        {data?.channel}
                                    </WinFormInput>
                                </td>
                                <td style={{width: '33.3%'}}>
                                    <WinFormInput id={`${windowName}-rob`} style={{width: '100%'}}>
                                        {data?.rob}
                                    </WinFormInput>
                                </td>
                            </tr>
                        </table>

                        <table style={{width: '100%', marginBottom: 6}}>
                            <tr>
                                <td colSpan={3} style={{textAlign: 'center', backgroundColor: '#008080', color: 'white'}}>Manning's n Values</td>
                            </tr>
                            <tr>
                                <ResultHeaderCell style={{textAlign: 'center', width: 60,}}>LOB</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'center', width: 60,}}>Channel</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'center', width: 60,}}>ROB</ResultHeaderCell>
                            </tr>
                            <tr>
                                <td style={{width: '33.3%'}}>
                                    <WinFormInput id={`${windowName}-mann-lob`} style={{width: '100%'}}>
                                        {data?.mann_lob}
                                    </WinFormInput>
                                </td>
                                <td style={{width: '33.3%'}}>
                                    <WinFormInput id={`${windowName}-mann-channel`} style={{width: '100%'}}>
                                        {data?.mann_channel}
                                    </WinFormInput>
                                </td>
                                <td style={{width: '33.3%'}}>
                                    <WinFormInput id={`${windowName}-mann-rob`} style={{width: '100%'}}>
                                        {data?.mann_rob}
                                    </WinFormInput>
                                </td>
                            </tr>
                        </table>

                        <table style={{width: '100%', marginBottom: 6}}>
                            <tr>
                                <td colSpan={3} style={{textAlign: 'center', backgroundColor: '#008080', color: 'white'}}>Main Channel Bank Stations</td>
                            </tr>
                            <tr>
                                <ResultHeaderCell style={{textAlign: 'center', width: 90,}}>Left Bank</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'center', width: 90,}}>Right Bank</ResultHeaderCell>
                            </tr>
                            <tr>
                                <td style={{width: 90}}>
                                    <WinFormInput id={`${windowName}-left-bank`} style={{width: '100%'}}>
                                        {data?.left_bank}
                                    </WinFormInput>
                                </td>
                                <td style={{width: 90}}>
                                    <WinFormInput id={`${windowName}-right-bank`} style={{width: '100%'}}>
                                        {data?.right_bank}
                                    </WinFormInput>
                                </td>
                            </tr>
                        </table>

                        <table style={{width: '100%', marginBottom: 6}}>
                            <tr>
                                <td colSpan={3} style={{textAlign: 'center', backgroundColor: '#008080', color: 'white'}}>Cont\Exp Coefficient (Steady)</td>
                            </tr>
                            <tr>
                                <ResultHeaderCell style={{textAlign: 'center', width: 90,}}>Contraction</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'center', width: 90,}}>Expansion</ResultHeaderCell>
                            </tr>
                            <tr>
                                <td style={{width: 90}}>
                                    <WinFormInput id={`${windowName}-cont`} style={{width: '100%'}}>
                                        {data?.cont}
                                    </WinFormInput>
                                </td>
                                <td style={{width: 90}}>
                                    <WinFormInput id={`${windowName}-exp`} style={{width: '100%'}}>
                                        {data?.exp}
                                    </WinFormInput>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}